/** Quiet zone around the code, in modules. Four is the QR spec minimum. */
export const QR_QUIET_ZONE = 4

/** The slice of `qrcode-generator`'s model this needs, so tests can fake it. */
export type QrModel = {
  getModuleCount(): number
  isDark(row: number, col: number): boolean
}

/**
 * One SVG path covering every dark module, in a viewBox of
 * `getModuleCount() + 2 * QR_QUIET_ZONE` units square.
 *
 * Modules are addressed `(row, col)` and drawn `(x = col, y = row)`. Getting
 * that the wrong way round produces a transposed code that looks plausible and
 * scans on nothing, which is why this is a separate, tested function rather
 * than a loop inside the component.
 */
export function buildQrModulePath(qr: QrModel): string {
  const count = qr.getModuleCount()
  const parts: string[] = []
  for (let row = 0; row < count; row += 1) {
    for (let col = 0; col < count; col += 1) {
      if (qr.isDark(row, col)) {
        parts.push(`M${col + QR_QUIET_ZONE} ${row + QR_QUIET_ZONE}h1v1h-1z`)
      }
    }
  }
  return parts.join('')
}

export function qrViewBoxSide(qr: QrModel): number {
  return qr.getModuleCount() + QR_QUIET_ZONE * 2
}
